import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface SideNavContextType {
  navOpen: boolean;
  rightPanelOpen: boolean;
  setNavOpen: (open: boolean) => void;
  setRightPanelOpen: (open: boolean) => void;
  toggleDrawer: () => void;
  toggleRightPanel: () => void;
}

const SideNavContext = createContext<SideNavContextType | undefined>(undefined);

export const SideNavProvider = ({
  children,
  initialOpen = false,
  initialRightPanelOpen = false,
}: {
  children: ReactNode;
  initialOpen?: boolean;
  initialRightPanelOpen?: boolean;
}) => {
  const [navOpen, setNavOpen] = useState(initialOpen);
  const [rightPanelOpen, setRightPanelOpen] = useState(initialRightPanelOpen);

  const toggleDrawer = () => setNavOpen((prev) => !prev);
  const toggleRightPanel = () => setRightPanelOpen((prev) => !prev);

  return (
    <SideNavContext.Provider
      value={{
        navOpen,
        rightPanelOpen,
        setNavOpen,
        setRightPanelOpen,
        toggleDrawer,
        toggleRightPanel,
      }}
    >
      {children}
    </SideNavContext.Provider>
  );
};

export const useSideNav = () => {
  const context = useContext(SideNavContext);
  if (!context) {
    throw new Error('useSideNav must be used within a SideNavProvider');
  }
  return context;
};
